import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ApiHelper} from './api.helper';
import {ModalsControlService} from './modals-control.service';
import {InfoModalContent} from '../types/InfoModalContent';
import {ModalCommand} from '../types/ModalCommand';
import {ModalTypeEnum} from '../enums/ModalEnums';
import {AppConfigService} from './app-config.service';

@Injectable()
export class MailchimpService {
  private mailChimpEndpoint: string;

  constructor(
    private http: HttpClient,
    private apiHelper: ApiHelper,
    private modalControl: ModalsControlService,
    private appConfigService: AppConfigService,
  ) {
    this.mailChimpEndpoint = `https://mc.us5.list-manage.com/subscribe/form-post-json?u=${appConfigService.appConfig.mailchimp_uid}&id=${appConfigService.appConfig.mailchimp_lid}`;
  }

  SubscribeToList(email: string): Observable<any> {
    const params = new HttpParams()
      .set('EMAIL', email)
      .set(`b_${this.appConfigService.appConfig.mailchimp_uid}_${this.appConfigService.appConfig.mailchimp_lid}`, '');
    const mailChimpUrl = `${this.mailChimpEndpoint}&${params.toString()}`;
    return this.http.jsonp(mailChimpUrl, 'c').pipe(catchError((error) => this.apiHelper.handleError(error)));
  }

  OpenSuccessModal(): void {
    const infoContent: InfoModalContent = {
      title: 'Snart är du prenumerant på vårt nyhetsbrev!',
      message:
        '<p>Allt du behöver göra nu är att bekräfta din prenumeration genom att klicka ' +
        'på länken i e-postmeddelandet vi precis skickade till dig</p>',
    };
    const modalCommand: ModalCommand = {
      type: ModalTypeEnum.INFO,
      data: infoContent,
    };
    this.modalControl.openModal(modalCommand);
  }

  OpenErrorModal(msg: string): void {
    const infoContent: InfoModalContent = {
      title: 'Hoppsan, något gick snett',
      message: '<p>' + msg + '</p>',
    };
    const modalCommand: ModalCommand = {
      type: ModalTypeEnum.INFO,
      data: infoContent,
    };
    this.modalControl.openModal(modalCommand);
  }
}
